import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ImageSlider extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get imageSlides() {
    return get(this, '_image_slides', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/ImageSlider.model.js